import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import ContextProvider from './context/ContextProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { theme } from './themes/theme';

import './index.css'

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ContextProvider>
        <BrowserRouter >
          <Routes >
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </ContextProvider>
    </ThemeProvider>
  </React.StrictMode>
);
